<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">
        Отправить СМС с авторегистрацией и ссылкой на витрину
      </p>
    </header>

    <section class="modal-card-body">
      <b-field expanded label="Шаблон СМС">
        <b-input
          expanded
          maxlength="200"
          type="textarea"
          v-model="text_template_a"
        ></b-input>
      </b-field>

      <div class="columns">
        <div class="column">
          <p>Доступные переменные:</p>
          <p><b>{short_link}</b> - Короткая ссылка</p>
          <p><b>[item1|item2|...]</b> - Случайный выбор из вариантов</p>
        </div>
        <div class="column" v-if="!!text_template_a">
          <p>Максимальная длина СМС</p>
          <p>
            <b>{{ max_sms.length }}</b
            >: {{ max_sms }}
          </p>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <p><b>Пример:</b></p>
          <p>
            [Займ|Заем|Заём] без процентов от [банк|банка] инфо {short_link}
          </p>
          <p>З=аём без процентов от бан;ка инфо {short_link}</p>
        </div>
        <div class="column">
          <b-field label="Оффер">
            <b-select placeholder="" icon="duck" v-model="offer_id">
              <option v-for="offer in offers" :value="offer.id" :key="offer.id">
                {{ offer.name }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
    </section>

    <div class="modal-card-foot is-block">
      <div class="">
        <div class="is-pulled-right">
          <b-button type="is-default" @click="$parent.close()"
            >Закрыть</b-button
          >
          <b-button type="is-primary" @click="send()">Отправить</b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AxiosClient } from "@/app/shared/services";

export default {
  name: "AutoRegistrationSmsTemplate",
  data() {
    return {
      text_template_a: "",
      offer_id: "",
    };
  },
  computed: {
    offers() {
      return this.$store.getters.OFFERS;
    },
    max_sms() {
      if (!!this.text_template_a) {
        // prettier-ignore
        var re = /\[([0-9А-Яа-яё\.\,\s\|]*)\]/gm;
        var tmp = this.text_template_a;
        // [Займ|Заем|Заём] без процентов от [банк|банка] инфо {short_link}
        var replacements = this.text_template_a.match(re);
        var repl_dict = {};
        if (replacements) {
          for (let index = 0; index < replacements.length; index++) {
            const element = replacements[index];
            repl_dict["f" + index] = element.replace(/\[|\]/gm, "").split("|");
            tmp = tmp.replace(element, "f" + index);
          }
          for (const key of Object.keys(repl_dict)) {
            tmp = tmp.replace(
              key,
              this.rand_replace(
                repl_dict[key].reduce(
                  (r, s) => (r.length > s.length ? r : s),
                  0
                )
              )
            );
          }
          console.log(repl_dict);
        }

        return tmp;
      }
    },
  },
  created() {
    this.$store.dispatch("GET_OFFERS");
  },
  props: ["utm_source", "file"],
  methods: {
    send() {
      const formData = new FormData();
      formData.append("utm_source", this.utm_source);
      formData.append("file", this.file);
      formData.append("text_template_a", this.text_template_a);
      formData.append("offer_id", this.offer_id);

      AxiosClient.post("/profile/sms_with_auto_registration", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
        .then((data) => {
          this.$toaster.success("Рассылка запущена в фоновом режиме");
          this.$parent.close();
        })
        .catch((error) => {
          this.$toaster.error(`Ошибка!${error}`);
        });
    },
    rand_replace(str) {
      var r = ")(&%$!-=+/>”;#^~";
      var position = Math.floor(Math.random() * Math.floor(str.length));
      return (
        str.substring(0, position) +
        r[Math.floor(Math.random() * Math.floor(r.length))] +
        str.substring(position)
      );
    },
  },
};
</script>

<style>
</style>
